import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  class: "hidden"
}

import { Search, X } from "lucide-vue-next";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportFilters',
  props: {
    search: {},
    statusFilter: {},
    serviceFilter: {},
    serviceOptions: {},
    showServiceFilter: { type: Boolean }
  },
  emits: ["update:search", "update:status-filter", "update:service-filter"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Search), { class: "pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#94a3b8]" }),
      _createElementVNode("input", {
        value: __props.search,
        type: "text",
        placeholder: "Search clients",
        class: "w-full rounded-[0.95rem] border border-[#d3dce9] bg-white py-2.5 pl-10 pr-9 text-[0.92rem] text-[#243049] placeholder-[#94a3b8] outline-none transition focus:border-[#8eb4ff] focus:ring-2 focus:ring-[#cfe0ff]",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:search', ($event.target as HTMLInputElement).value)))
      }, null, 40, _hoisted_3),
      (__props.search)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-[#94a3b8] hover:text-[#475569]",
            title: "Clear search",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:search', '')))
          }, [
            _createVNode(_unref(X), { class: "h-4 w-4" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("select", {
        value: __props.statusFilter,
        class: "compact-select",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:status-filter', ($event.target as HTMLSelectElement).value)))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("option", { value: "all" }, " All Statuses ", -1),
        _createElementVNode("option", { value: "none" }, " No Reports ", -1),
        _createElementVNode("option", { value: "partial" }, " Partially Ready ", -1),
        _createElementVNode("option", { value: "full" }, " Fully Ready ", -1)
      ]))], 40, _hoisted_5),
      (__props.showServiceFilter)
        ? (_openBlock(), _createElementBlock("select", {
            key: 0,
            value: __props.serviceFilter,
            class: "compact-select",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:service-filter', ($event.target as HTMLSelectElement).value)))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, " All Packages ", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.serviceOptions, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option
              }, _toDisplayString(option), 9, _hoisted_7))
            }), 128))
          ], 40, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_8))
    ])
  ]))
}
}

})